var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95503",
    "data-name": "Path 95503",
    d: "M19.5,16.5a3,3,0,1,1-3-3A3,3,0,0,1,19.5,16.5Z",
    transform: "translate(-5.5 -5.5)",
    fill: "none",
    stroke: "#ffb600",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95504",
    "data-name": "Path 95504",
    d: "M19.9,15.5a1.65,1.65,0,0,0,.33,1.82l.06.06a2,2,0,1,1-2.83,2.83l-.06-.06a1.663,1.663,0,0,0-2.82,1.18v.17a2,2,0,0,1-4,0v-.09A1.65,1.65,0,0,0,9.5,19.9a1.65,1.65,0,0,0-1.82.33l-.06.06a2,2,0,1,1-2.83-2.83l.06-.06a1.663,1.663,0,0,0-1.18-2.82H3.5a2,2,0,1,1,0-4h.09A1.65,1.65,0,0,0,5.1,9.5a1.65,1.65,0,0,0-.33-1.82l-.06-.06A2,2,0,1,1,7.54,4.79l.06.06a1.65,1.65,0,0,0,1.82.33H9.5a1.65,1.65,0,0,0,1-1.51V3.5a2,2,0,1,1,4,0v.09a1.663,1.663,0,0,0,2.82,1.18l.06-.06a2,2,0,1,1,2.83,2.83l-.06.06a1.65,1.65,0,0,0-.33,1.82V9.5a1.65,1.65,0,0,0,1.51,1h.17a2,2,0,1,1,0,4h-.09a1.65,1.65,0,0,0-1.51,1Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.58a39f657cb638ec4265ebdac042824b.svg";
export { ForwardRef as ReactComponent };